// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2493":"a0b9d807","3247":"d3fede2f","3499":"d3fede2f","3567":"d3fede2f","5575":"af0de118","6394":"484a0d3d"}[chunkId] + ".chunk.css";
};